import { Component, Input, OnInit } from "@angular/core"

@Component({
  selector: "app-ai-variables-add-edit-modal",
  templateUrl: "./ai-variables-add-edit-modal.component.html",
  styleUrls: ["./ai-variables-add-edit-modal.component.scss"],
})
export class AiVariablesAddEditModalComponent implements OnInit {
  constructor() {}

  public isAILegendSelected: Boolean = false
  public selectedEditLegend: any = null

  @Input('templateActiveTabEvt') templateActiveTabEvt: string

  ngOnInit(): void {
    this.isAILegendSelected = this.templateActiveTabEvt === "ai_variables";
  }

  // editVariable(id: number) {
  //   const legendToEdit = this.selectedLegend.find(legend => legend.id === id)

  //   if (legendToEdit) {
  //     this.selectedEditLegend = {
  //       ...legendToEdit,
  //       prompt: legendToEdit.prompt || "",
  //       preview: legendToEdit.preview || "",
  //     }
  //   }
  // }

  updateAIVar() {
    // console.log("Saving:", this.selectedEditLegend)
    this.selectedEditLegend = null
  }
}
